/** LiveArt script */
(function (LiveArt) {

  /**
    Customize button logic
    Update designer link with selected variant before redirect
    May need customization according to your theme
    Liveart product id is expected to be specified in data-liveart-product-id button attribute
    Selected variant can be provided in the following ways:
      - data-selected-variant-id attribute
      - variant_selector - selector of the master variants input
      - otherwise attempt to get variant from URL query
  */
  LiveArt.redirectToDesigner = function (event, variant_selector) {
    if (event.preventDefault) event.preventDefault();
    var liveartProductId = event.target.dataset.liveartProductId;
    var variant = event.target.dataset.selectedVariantId;
    if (!variant) {
      var variantEl = document.querySelector(variant_selector + '');
      if (variantEl && variantEl.tagName === 'SELECT')
        variant = variantEl.selectedOptions[0].value || variant;
      else if (variantEl && variantEl.tagName === 'INPUT') {
        variant = variantEl.value || variant;
      } else {
        variant = new URLSearchParams(window.location.search).get('variant');
      }
    }
    var url = new URL(window.location.href);
    url.pathname = '/pages/liveart-designer';
    var searchParams = new URLSearchParams();
    searchParams.set('product_id', liveartProductId);
    if (variant) searchParams.set('ext_variant_id', variant + '');
    url.search = searchParams.toString();
    window.location.href = url;
  };

}(window.LiveArt = window.LiveArt || {}));
